/* eslint-disable func-names */
/* eslint-disable no-undef */
const teamCard = () => {
  (function ($) {
    const $body = $('body');

    $body.on('click', '.js-phone', (e) => {
      const isMobile = window.matchMedia('(max-width: 767px)').matches;

      if (!isMobile) {
        e.preventDefault();

        const $span = $(e.currentTarget).find('span');

        const prev = $span.text();
        const next = $span.attr('data-temp');

        $span.attr('data-temp', prev);
        $span.text(next);
      }
    });
  }(jQuery));
};

export default teamCard;
